export default __webpack_public_path__ + "static/media/container.cb1f4e58.svg";